import { combineReducers } from 'redux';
import { reducer as app } from 'src/AppReducer';

export default combineReducers({
    app,
});
